<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      default:
        'Die von Ihnen eingegebene Postleitzahl ist entweder ungültig oder wir haben diese noch nicht in unsere ' +
        'Datenbank eingepflegt. Erfragen Sie Ihren Preis über unser'
    },
    link: {
      type: String,
      default: 'preisanfrage.html'
    },
    label: {
      type: String,
      default: 'Preisanfrageformular'
    },
    title: String,
    customStyle: {
      default: null
    },
    visible: Boolean,
    isError: Boolean,
    variant: {
      type:Number,
      default: 0}
  },
};
</script>
<template>
  <div v-if="visible">
    <div class="popover fade bottom in tooltip-wrapper" :style="Number(this.variant) === 1 ? {left : '0px !important'} : null"  role="tooltip">
      <div class="arrow"></div>
      <div v-if="isError">
        <div class="popover-content tooltip-has-error">
          <span class="tooltip-error-text">
            {{ text }}
          </span>
        </div>
      </div>
      <div v-else>
        <h3 v-if="title" class="popover-title">{{ title }}</h3>
        <div class="popover-content">
          <span class="tooltip-text">
            {{ text }}
            <a class="btn btn-primary mt-10 btn-block" :href="link">{{ label }}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="scss">
.tooltip-has-error {
  display: flex;
  align-items: center;
}
.tooltip-error-text {
  color: black !important;
  font-size: 14px;
  padding-left: 10px;
}
.tooltip-wrapper {
  width: 250px;
  top: 0px;
  left: 0px;
  display: block;
  position: absolute;

  @media (max-width: 800px) {
    width: 100% !important;
    left: 23% !important;
  }
}
.arrow{
  left: 10px !important;
}
.tooltip-text {
  color: #000;
}
</style>
